var TotalJobsGroup = TotalJobsGroup || {};
TotalJobsGroup.Header = TotalJobsGroup.Header || {};

TotalJobsGroup.Config = TotalJobsGroup.Config || {};
TotalJobsGroup.Config.Global = TotalJobsGroup.Config.Global || {};

TotalJobsGroup.Header.UserAgent = TotalJobsGroup.Header.UserAgent || {};

TotalJobsGroup.Header.AutoCompleteService = TotalJobsGroup.Header.AutoCompleteService || {};

TotalJobsGroup.Header.SearchAutoComplete = (function ($, config, userAgent, autoCompleteService) {
    "use strict";
    //
    // Wires up the keywords and location textboxes to use their respective auto-suggest
    // web services when a key is typed, using the jQuery.UI autocomplete plugin.
    // The X button is also shown on the keywords/location textboxes after autocomplete is selected.
    // (This library is also in the homepage).

    //
    // NOTE: We are using jQuery.UI 1.10 as there is a bug in 1.11 with autocomplete:
    // http://bugs.jqueryui.com/ticket/10544 - iPhone will not work with 1.11!
    //

    var _keywordsSelector = ".search-keywords";
    var _locationSelector = ".search-location-text";
    var _locationSearchTypeSelector = ".search-locationsearchtype";
    var headerWhatInput = $("#header-desktop-search-keywords");
    var headerMobileWhatInput = $("#header-mobile-search-keywords");
    var homepageWhatInput = $(".homepage-what #keywords");
    var headerTypeField = $(".search-keyword-type");

    var _globalConfig, _userAgent, _autoCompleteService;

    function setGlobalConfig(globalConfig) {
        _globalConfig = globalConfig;
    }

    function setUserAgent(userAgent) {
        _userAgent = userAgent;
    }

    function setAutoCompleteService(autoCompleteService) {
        _autoCompleteService = autoCompleteService;
    }

    function escapeRegExp(text) {
        return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }

    setGlobalConfig(config);
    setUserAgent(userAgent);
    setAutoCompleteService(autoCompleteService);

    function highlightKeyword(autoSuggestItem, term) {
        var keywords = term.split(" ").join("|");
        keywords = escapeRegExp(keywords);
        return autoSuggestItem.replace(new RegExp("(" + keywords + ")", "gi"), "<b>$1</b>");
    }

    function bindKeywordsAutocomplete(searchBar) {
        var maxResults = _globalConfig.KeywordsAutoSuggestMaxResults;
        // Less results for mobile
        if (_userAgent !== undefined && $.isFunction(_userAgent.isMobileScreenWidth) && _userAgent.isMobileScreenWidth() === true) {
            maxResults = _globalConfig.KeywordsAutoSuggestMaxResultsMobile;
        }
        var keywordAutocomplete = $(_keywordsSelector, searchBar).autocomplete({
            position: { my: "left top", at: "left bottom" },
            delay: _globalConfig.KeywordsAutoSuggestDelayMilliseconds,
            minLength: 2,
         
            source: function (request, response) {
                var jsonData = { "value": request.term, "MaxResults": maxResults };

                _autoCompleteService.search({
                    url: _globalConfig.KeywordsAutoSuggestUrl,
                    data: jsonData,
                    successCallback: function (data) {
                        if (data.Results !== null && data.Results.length !== 0) {
                            response($.map(data.Results,
                                function (item) {
                                    return { value: item.DisplayString, type: item.Type, term: request.term };
                                }));
                        }
                    }
                });
            },
            open: function (e, ui) {
            },
            select: function (e, ui) {
                updateKeywordTypeToHiddenFields(ui.item.type);
                addTypeValueToSessionStorage(ui.item.type);
            }
        });

        keywordAutocomplete.data("ui-autocomplete")._renderItem = function (ul, item) {
            return $("<li class=\"ui-menu-item\" role=\"presentation\"></li>")
                .append("<a>" + highlightKeyword(item.value, item.term) + "<span class=\"autocomplete-type\">" + item.type + "</span></a>")
                .appendTo(ul);
        };
    }

    function onKeyupUpdateKeywordType(evt) {
        var keywordText = "KEYWORD";
        var KEY_UP = 38;
        var KEY_DOWN = 40;
        var KEY_ENTER = 13;

        if (evt.which !== KEY_DOWN && evt.which !== KEY_UP && evt.which !== KEY_ENTER) {
            if (!$.isNullOrUndefined(headerWhatInput) && headerWhatInput.val() !== "") {
                headerTypeField.val(keywordText);
            }

            if (!$.isNullOrUndefined(headerMobileWhatInput) && headerMobileWhatInput.val() !== "") {
                headerTypeField.val(keywordText);
            }

            if (!$.isNullOrUndefined(homepageWhatInput) && homepageWhatInput.val() !== "") {
                headerTypeField.val(keywordText);
            }
        }
    }

    function clearTypeField() {
        headerTypeField.val("");
    }

    function checkToClearTypeField() {
        if ((!$.isNullOrUndefined(headerWhatInput) && headerWhatInput.val() === "")) {
            if (!headerMobileWhatInput.is(":hidden")) {
                clearTypeField();
            }
        }

        if ((!$.isNullOrUndefined(headerMobileWhatInput) && headerMobileWhatInput.val() === "")) {
            if (!headerMobileWhatInput.is(":hidden")) {
                clearTypeField();
            }
        }

        if ((!$.isNullOrUndefined(homepageWhatInput) && homepageWhatInput.val() === "")) {
            if (!homepageWhatInput.is(":hidden")) {
                clearTypeField();
            }
        }
    }

    function updateKeywordTypeToHiddenFields(type) {
        headerTypeField.val(type);
    }

    function showOrHideElementOnStringLength(stringToCheck, elementToChange) {
        // hides the "X" if the textbox text goes over a certain length.
        var minLength = 2;
        if ($.type(stringToCheck) === 'string') {
            var length = stringToCheck.length;
            if (length >= minLength) {
                elementToChange.show();
            } else {
                elementToChange.hide();
            }
        }
    }

    function bindlocationAutocomplete(searchBar) {

        $.widget('custom.extend_autocomplete', $.ui.autocomplete, {
            _create: function () {
                this._super();
                this.widget().menu("option", "items", "> :not(.ui-autocomplete-header)");
            },
            _renderMenu: function (ul, items) {
                var self = this,
                    list = $('<div class="ui-autocomplete-header"></div>');
                if (this.options.showHeader)
                {
                    list.append('<span>' + this.options.headerText + '</span>');
                    ul.append(list);
                }
                $.each(items, function (index, item) {
                    self._renderItemData(ul, item);
                });
            },
            _renderItemData: function (ul, item) {
                return this._renderItem(ul, item).data("ui-autocomplete-item", item);
            },
            _renderItem: function (ul, item) {
                var result = '';

                result = $('<li>', {
                    class: "ui-menu-item",
                    role: "presentation"
                })
                    .append('<a>' + highlightKeyword(item.value, item.term) + '<div></div></a>')
                    .appendTo(ul);

                return result;
            }
        });

        var maxResults = _globalConfig.LocationMaxResults;

        // Less results for mobile
        if (_userAgent !== undefined && $.isFunction(_userAgent.isMobileScreenWidth) && _userAgent.isMobileScreenWidth() === true) {
            maxResults = _globalConfig.LocationMaxResultsMobile;
        }

        function _doFocusStuff(event, ui) {
            if (ui.item && ui != null) {
                $(_locationSelector, searchBar).val(ui.item.value);
            }
        }

        var locationAutocomplete = $(_locationSelector, searchBar).extend_autocomplete({
            position: { my: "left top", at: "left bottom" },
            delay: _globalConfig.LocationDelayMilliseconds,
            focus: _doFocusStuff,
            minLength: 2,
            showHeader: isCommuteTimeEnabledSite(),
            headerText: "Add postcode for commute time",
            source: function (request, response) {
                var jsonData = { "lookupText": request.term, "numberOfResults": maxResults };
          
                _autoCompleteService.search({
                    url: _globalConfig.LocationWebServiceUrl,
                    data: jsonData,
                    successCallback: function (data) {
                        if (data.d.Items !== null && data.d.Items.length !== 0) {
                            response($.map(data.d.Items,
                                function (item) {
                                    return { value: item, term: request.term };
                                }));
                        }
                    }
                });
            },
            open: function (e, ui) {
            },
            close: function ()
            {
                if (_userAgent !== undefined && $.isFunction(_userAgent.isMobileSafari) && _userAgent.isMobileSafari() === true) {
                    // Hide the X button for long location names, as it looks ugly.
                    if ($(_locationSelector).val().length > 20) {
                        $(".clear-location", searchBar).hide();
                    }

                    $(_locationSelector).focus();
                }

                if (isCommuteTimeEnabledSite() &&
                    isValidPostcode($(_locationSelector, searchBar).val()) &&
                    $(_locationSearchTypeSelector, searchBar).val().lastIndexOf("CTD_", 0) !== 0 // if doesn't start with "CTD_"
                )
                {
                    var defaultCommuteTimeValue = 'CTD_45';

                    // Don't try to change the dropdown value if default commuteTime value is not in the list
                    $(_locationSearchTypeSelector, searchBar).find("option").each(function ()
                    {
                        if (this.value === defaultCommuteTimeValue) {
                            $(_locationSearchTypeSelector, searchBar).val(defaultCommuteTimeValue);
                        }
                    });
                }
            }
        });
    }

    function setupClearKeywords(searchBar) {
        // X button for clearing the keywords textbox on safari mobile

        var keywordClear = $(".clear-keywords", searchBar);
        var locationClear = $(".clear-location", searchBar);

        keywordClear.click(function () {
            showOrHideElementOnStringLength($(this).val(), keywordClear);
            $(".ui-autocomplete", searchBar).hide();
            $(_keywordsSelector, searchBar).val("").focus();
        });

        // X button for clearing the location textbox on safari mobile
        locationClear.click(function () {
            showOrHideElementOnStringLength($(this).val(), locationClear);
            $(".ui-autocomplete", searchBar).hide();
            locationClear.hide();
            $(_locationSelector, searchBar).val("").focus();
        });

        if (_userAgent !== undefined && $.isFunction(_userAgent.isMobileSafari) && _userAgent.isMobileSafari() === true) {
            $(_keywordsSelector, searchBar).on("keyup change", function () {
                showOrHideElementOnStringLength($(this).val(), keywordClear);
            });

            $(_locationSelector, searchBar).on("keyup change", function () {
                showOrHideElementOnStringLength($(this).val(), locationClear);
            });
        }
    }

    function addTypeToSessionStorage() {
        var searchType = new Object();
        searchType.type = headerTypeField.val();
        sessionStorage.setItem("searchType", JSON.stringify(searchType));
    }

    function addTypeValueToSessionStorage(keywordtype) {
        sessionStorage.setItem("searchType", JSON.stringify({ type: keywordtype }));
    }

    function isCommuteTimeEnabledSite() {
        var commutetimeSites = TotalJobsGroup.Config.Global.CommuteTimeSearchEnabledSites;
        var currentSite = TotalJobsGroup.Config.Site.Site;

        if ($.inArray(currentSite, commutetimeSites) > -1 ) {
            return true;
        } else {
            return false;
        }
    }

    function isValidPostcode(postcode) {
        var postcodeRegex = new RegExp(/^([A-Za-z]{1,2}[0-9]{1,2}[A-Za-z]?)\s?([0-9][A-Za-z]{2})?$/);
        var sanitizedPostcode = postcode.split(/,/)[0].trim();
        var result = postcodeRegex.exec(sanitizedPostcode);
        if (!result || result.length < 1)
            return false;
        return true;
    }

    function initialize(searchBar) {
        if ($.fn.autocomplete) {
            bindKeywordsAutocomplete(searchBar);
            bindlocationAutocomplete(searchBar);
            setupClearKeywords(searchBar);
        }
    }

    function populateTypeFromSessionStorage() {
        var searchType = new Object();
        if (sessionStorage.getItem("searchType") !== null) {
            searchType = JSON.parse(sessionStorage.getItem("searchType"));
            if (!$.isNullOrUndefined(searchType.type)) {
                headerTypeField.val(searchType.type);
            }
        }
    }
    function registerInit() {
        $(document).ready(function () {
            if (headerTypeField.val() !== undefined) {
                populateTypeFromSessionStorage();
            }

            $(".navbar-site-search-bar").each(function (index, element) {
                initialize($(element));
            });

            $(_keywordsSelector).keyup(function (evt) {
                onKeyupUpdateKeywordType(evt);
            });

            $(_keywordsSelector).change(function () {
                checkToClearTypeField();
            });

            $(_keywordsSelector).submit(function () {
                checkToClearTypeField();
            });

            $(".search-submit-button").click(function () {
                addTypeToSessionStorage();
            });
        });
    }

    try {
        registerInit();
    }
    catch (e) {
    }

    return {
        setAutoCompleteService: setAutoCompleteService,
        setGlobalConfig: setGlobalConfig,
        setUserAgent: setUserAgent,
        initialize: initialize
    }
}(jQuery, TotalJobsGroup.Config.Global, TotalJobsGroup.Header.UserAgent, TotalJobsGroup.Header.AutoCompleteService));


